import { Injectable, signal } from '@angular/core';

/**
 * Состояние проекта для подсказок онбординга: заполняет страница альбомов,
 * читают хосты якорей вне страницы (шапка, кнопка скачивания, диалог ссылки).
 */
@Injectable({ providedIn: 'root' })
export class AlbumsCoachState {
  readonly projectId = signal<string | null>(null);
  readonly hasApproved = signal(false);
  readonly flowMode = signal<'studentAssembles' | 'photographerAssembles' | null>(null);
  readonly isDemo = signal(true);

  set(next: {
    projectId: string;
    hasApproved: boolean;
    flowMode: 'studentAssembles' | 'photographerAssembles' | null;
    isDemo: boolean;
  }): void {
    this.projectId.set(next.projectId);
    this.hasApproved.set(next.hasApproved);
    this.flowMode.set(next.flowMode);
    this.isDemo.set(next.isDemo);
  }

  clear(): void {
    this.projectId.set(null);
    this.hasApproved.set(false);
    this.flowMode.set(null);
    this.isDemo.set(true);
  }
}
